export default __webpack_public_path__ + "static/media/alipay.a10bbdf9.svg";